import { PayloadAction, createSlice } from "@reduxjs/toolkit";


export interface UserDetails {
    name:string,
    isAdmin: boolean,
    isManager: boolean,
    isStaff: boolean,
    isOwner: boolean,
    customerId?: string,
    id: string
}

export type UserRole = 'isAdmin' | 'isManager' | 'isStaff' | 'isOwner';

const initialState: UserDetails = {
    name: "",
    isAdmin: false,
    isManager: false,
    isStaff: false,
    isOwner: false,
    customerId: "",
    id: "",
};

const authSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser (_state, action: PayloadAction<Partial<UserDetails> | undefined>) {
            return {
                ...initialState,
                ...action.payload,
            };
        },
        clearUser () {
            return initialState;
        }
    },
})

export const {setUser, clearUser} = authSlice.actions;
export default authSlice.reducer;